// /* eslint-disable eqeqeq */
// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { Modal as ANTDModal } from "antd";
// import SimpleBar from "simplebar-react";
// import {
//   Navbar,
//   UncontrolledDropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
//   Button,
//   Row,
//   Col,
//   Table,
//   ModalHeader,
//   Modal,
//   ModalBody,
// } from "reactstrap";
// import { Link, useNavigate } from "react-router-dom";
// import * as Icon from "react-feather";
// import Logo from "../logo/Logo";
// import {
//   ToggleMiniSidebar,
//   ToggleMobileSidebar,
// } from "../../store/customizer/CustomizerSlice";
// import ProfileDD from "./ProfileDD";
// // import qr from '../../assets/images/icons/qr.png';
// import phonepe from "../../assets/images/icons/phonepe.png";
// import gpay from "../../assets/images/icons/gpay.png";
// import paytm from "../../assets/images/icons/paytm.png";
// import upi from "../../assets/images/icons/upi.png";
// // import qrImage from '../../assets/images/download.png';
// import { logout } from "../../slices/authSlice/userSilce";
// import MessageDD from "./MessageDD";
// import NotificationDD from "./NotificationDD";

// // import UserBalance from '../../components/common/userBalance';
// import { fetchData } from "../../slices/authSlice/dataSlice";
// import user1 from "../../assets/images/users/user1.jpg";
// import mobLogo from "../../assets/images/logos/logo-mob.png";
// import ReactStrapModal from "../../components/common/reactStrapModal";
// import CreditSelfAdmin from "../../views/Admin/ManageCreditDetails/CreditSelfAdmin";
// import { consoleEnableKey } from "../../components/common/constant";
// import { GetDataActiveDeactive } from "../../slices/admin/Management/managementSlice";
// import _ from "lodash";

// const Header = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const isDarkMode = useSelector((state) => state.customizer.isDark);
//   const topbarColor = useSelector((state) => state.customizer.topbarBg);
//   const { consoleEnable } = useSelector((state) => state.managementSlice);
//   const { user: currentUser, token: Usertoken } = useSelector(
//     (state) => state.user
//   );
//   const [openWalletModal, setOpenWalletModal] = useState(false);
//   const [modal, setModal] = useState(false);
//   const [showBalance, setshowBalance] = useState(false);
//   const [ShowCloseMenuButton, setShowCloseMenuButton] = useState(false);

//   useEffect(() => {
//     dispatch(fetchData({ Usertoken, currentUser }));
//   }, [dispatch]);

//   const loginData = useSelector((state) => state.data.items);

//   const handleLogoutClick = () => {
//     ANTDModal.confirm({
//       title: "Logout",
//       content: "Are you sure to Logout?",
//       onCancel() {},
//       onOk() {
//         window.addEventListener("beforeunload", () => {
//           dispatch(logout());
//         });
//         navigate("/", { replace: true });
//         window.location.reload();
//       },
//     });
//   };
//   //
//   const toggle = () => {
//     setModal(!modal);
//   };

//   const getConsoleEnableDat = () => {
//     if (Usertoken && currentUser) {
//       const masterKey = consoleEnableKey;
//       dispatch(GetDataActiveDeactive({ currentUser, Usertoken, masterKey }))
//     }
//   };

//   useEffect(() => {
//     if (_.isEmpty(consoleEnable)) {
//       getConsoleEnableDat();
//     }
//   }, [Usertoken, consoleEnable]);

//   return (
//     <>
//       <Navbar color={currentUser.role == "1" || currentUser.role == "2" || currentUser.role == "8" ? topbarColor : topbarColor}
//         dark={!isDarkMode}
//         light={isDarkMode}
//         expand="lg"
//         className={`${currentUser.role == "1" || currentUser.role == "2" || currentUser.role == "8" ? "topbarAdmin admin_head_bg" : "topbar"}
//         ${currentUser.role == "1" || currentUser.role == "2" ? "px-md-2" : ""}`}
//       >
//         {/********Logo*******/}
//         {currentUser.role == "1" || currentUser.role == "2" ? (
//           <Link to="/Dashboards/AdminDashboard" className="d-none d-lg-flex">
//             <Logo />
//           </Link>
//         ) : null}

//         {currentUser.role !== "1" || currentUser.role !== "2" ? (
//           <Button close size="sm" className="d-none" onClick={() =>{ dispatch(ToggleMobileSidebar()); setShowCloseMenuButton(false)}}/>
//         ) : null}

//         {currentUser.role !== "1" ? (
//           <div className="d-flex align-items-center">
//             <Button className="d-none d-lg-block toggle-btnStyle" onClick={() => dispatch(ToggleMiniSidebar())}>
//                 <i class="fa-solid fa-bars"/>
//             </Button>
//             <Button className={`${ShowCloseMenuButton? "d-none" : " d-none d-lg-none"}  toggle-btnStyle`} onClick={() =>{ dispatch(ToggleMobileSidebar()); setShowCloseMenuButton(true)}}>
//                 <i class="fa-solid fa-bars"/>
//             </Button>
//           </div>
//         ) : null}
// {/* className="d-sm-block d-lg-none toggle-btnStyle" */}
//         {currentUser.role == "1" ? (
//           <div className="logo-section">
//             <Link to="/Dashboards/AdminDashboard" className="d-sm-block d-lg-none">
//               <img src={mobLogo} width={40} alt="" />
//             </Link>
//             <Button className={`${ShowCloseMenuButton? "d-none" : " d-sm-block d-lg-none"}  toggle-btnStyle`} onClick={() =>{ dispatch(ToggleMobileSidebar()); setShowCloseMenuButton(true)}}>
//               <i class="fa-solid fa-bars"/>
//             </Button>
//             <Button close size="sm" className={` ${ShowCloseMenuButton ? "d-sm-block d-lg-none" : "d-none" }`} onClick={() =>{ dispatch(ToggleMobileSidebar()); setShowCloseMenuButton(false)}}/>
//           </div>
//         ) : null}

//         <div className="text-center d-flex flex-row" navbar>
//             <span className="header-text d-md-block d-none">
//               Dashboard - WELCOME, {loginData?.username}!
//             </span>
//         </div>

//         <div className="d-flex align-items-center">

//         {currentUser.role == "1" ? (
//           <span className="mr-20 d-md-block d-none" onClick={() => setOpenWalletModal(true)}>
//               <i className="bi bi-wallet2 wallet-icon"/>
//           </span>
//         ) :null}

//           <div className="wallet-box" onClick={() => setshowBalance(!showBalance)}>
//             <span>
//               {/* Balance : {`\u20B9`} {loginData?.main_Wallet_Balance} */}
//               {currentUser.userName === "PFRT000009" ? null : (
//                 <>
//                   Balance
//                   {showBalance && (
//                     <span className="balance-amount">
//                       : {`\u20B9`} {loginData?.main_Wallet_Balance}
//                     </span>
//                   )}
//                 </>
//               )}
//             </span>
//           </div>
//           {/******************************/}
//           {/**********Mega DD**********/}
//           {/******************************/}

//           {/******************************/}
//           {/**********Notification DD**********/}
//           {/******************************/}
//           {currentUser.RoleName !== "Admin" ? (
//             // <UncontrolledDropdown className="mx-1 hov-dd d-md-block d-none">
//             <UncontrolledDropdown className="mx-1 hov-dd   d-none">
//               <DropdownToggle
//                 className="bg-transparent border-0"
//                 color={topbarColor}
//               >
//                 <Icon.MessageSquare size={18} />
//               </DropdownToggle>
//               <DropdownMenu className="ddWidth">
//                 <div className="bg-info p-3 text-white rounded-top">
//                   Notification
//                 </div>
//                 <SimpleBar style={{ maxHeight: "350px" }}>
//                   <NotificationDD />
//                 </SimpleBar>
//                 <DropdownItem divider />
//                 <div className="p-2 px-3">
//                   <Button color="info" size="sm" block>
//                     Check All
//                   </Button>
//                 </div>
//               </DropdownMenu>
//             </UncontrolledDropdown>
//           ) : null}
//           {/******************************/}
//           {/**********Message DD**********/}
//           {/******************************/}
//           {currentUser.RoleName !== "Admin" ? (
//             // <UncontrolledDropdown className="mx-1 hov-dd d-md-block d-none">
//             <UncontrolledDropdown className="mx-1 hov-dd   d-none">
//               <DropdownToggle
//                 className="bg-transparent border-0"
//                 color={topbarColor}
//               >
//                 <Icon.Mail size={18} />
//               </DropdownToggle>
//               <DropdownMenu className="ddWidth">
//                 <div className="bg-danger p-3 text-white rounded-top">
//                   Messages
//                 </div>
//                 <SimpleBar style={{ maxHeight: "350px" }}>
//                   <MessageDD />
//                 </SimpleBar>
//                 <DropdownItem divider />
//                 <div className="p-2 px-3">
//                   <Button color="danger" size="sm" block>
//                     Check All
//                   </Button>
//                 </div>
//               </DropdownMenu>
//             </UncontrolledDropdown>
//           ) : null}
//           {/******************************/}
//           {/**********Profile DD**********/}
//           {/******************************/}
//           <UncontrolledDropdown>
//             <DropdownToggle className="logout-btn">
//               <span>
//                 {loginData?.firstName} {loginData?.lastName}
//               </span>
//               <img src={user1} alt="user" width="30" className="rounded-circle mx-1"/>
//             </DropdownToggle>
//             <DropdownMenu className="logout-box">
//               <ProfileDD />
//               <Button color="danger" size="sm" className="m-2" onClick={handleLogoutClick}>
//                   Logout
//               </Button>
//             </DropdownMenu>
//           </UncontrolledDropdown>
//         </div>
//       </Navbar>
//       {modal ? (
//         <Col xs="8" md="12">
//           <Modal isOpen={toggle} fade={false} toggle={toggle.bind(null)}>
//             <ModalHeader
//               toggle={toggle.bind(null)}
//               style={{ padding: "10px", color: "#000" }}
//             >
//               UPI Collection
//             </ModalHeader>
//             <ModalBody>
//               <Row className="row">
//                 <Col md="4">
//                   {/* <img
//                     src={baseB4 + QRimage}
//                     alt="123"
//                     style={{ width: '150px', border: '1px solid #dfe2e6' }}
//                   /> */}
//                 </Col>
//                 <Col md="8" className="mt-0">
//                   <Table className="table-bordered">
//                     <thead>
//                       <tr>
//                         <td className="text-nowrap text-black">Name </td>
//                       </tr>
//                       <tr>
//                         <td className="text-nowrap text-black">UPI ID </td>
//                         {/* <td>{UPIID}</td> */}
//                       </tr>
//                     </thead>
//                   </Table>
//                   <Row>
//                     <img
//                       src={phonepe}
//                       alt="phonepe"
//                       style={{ width: "60px" }}
//                     />
//                     <img src={gpay} alt="gpay" style={{ width: "60px" }} />
//                     <img src={upi} alt="upi" style={{ width: "60px" }} />
//                     <img src={paytm} alt="paytm" style={{ width: "60px" }} />
//                   </Row>
//                 </Col>
//               </Row>
//             </ModalBody>
//           </Modal>
//         </Col>
//       ) : null}
//       {openWalletModal && (
//         <ReactStrapModal
//           modal={openWalletModal}
//           setModal={() => setOpenWalletModal(false)}
//           isHeader
//           isToggle
//           title="Self TopUp"
//           className="editModelDmt"
//           size="sm"
//           styles={{ width: "400px" }}
//         >
//           <CreditSelfAdmin
//             setOpenWalletModal={() => setOpenWalletModal(false)}
//           />
//         </ReactStrapModal>
//       )}
//     </>
//   );
// };

// export default Header;

/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal as ANTDModal } from "antd";
import SimpleBar from "simplebar-react";
import {
  Navbar,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Row,
  Col,
  Table,
  ModalHeader,
  Modal,
  ModalBody,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import * as Icon from "react-feather";
import Logo from "../logo/Logo";
import {
  ToggleMiniSidebar,
  ToggleMobileSidebar,
} from "../../store/customizer/CustomizerSlice";
import ProfileDD from "./ProfileDD";
// import qr from '../../assets/images/icons/qr.png';
import phonepe from "../../assets/images/icons/phonepe.png";
import gpay from "../../assets/images/icons/gpay.png";
import paytm from "../../assets/images/icons/paytm.png";
import upi from "../../assets/images/icons/upi.png";
// import qrImage from '../../assets/images/download.png';
import { logout } from "../../slices/authSlice/userSilce";
import MessageDD from "./MessageDD";
import NotificationDD from "./NotificationDD";

// import UserBalance from '../../components/common/userBalance';
import { fetchData } from "../../slices/authSlice/dataSlice";
import user1 from "../../assets/images/users/user1.jpg";
import mobLogo from "../../assets/images/logos/logo-mob.png";
import ReactStrapModal from "../../components/common/reactStrapModal";
import CreditSelfAdmin from "../../views/Admin/ManageCreditDetails/CreditSelfAdmin";
import { consoleEnableKey } from "../../components/common/constant";
import { GetDataActiveDeactive } from "../../slices/admin/Management/managementSlice";
import _ from "lodash";
import QRToWallet from "../../views/Retailer/QRServices/QRToWallet";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDarkMode = useSelector((state) => state.customizer.isDark);
  const topbarColor = useSelector((state) => state.customizer.topbarBg);
  const { consoleEnable } = useSelector((state) => state.managementSlice);
  const { user: currentUser, token: Usertoken } = useSelector(
    (state) => state.user
  );
  const [openWalletModal, setOpenWalletModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [showBalance, setshowBalance] = useState(false);

  useEffect(() => {
    dispatch(fetchData({ Usertoken, currentUser }));
  }, [dispatch]);

  const loginData = useSelector((state) => state.data.items);

  const handleLogoutClick = () => {
    ANTDModal.confirm({
      title: "Logout",
      content: "Are you sure to Logout?",
      onCancel() { },
      onOk() {
        window.addEventListener("beforeunload", () => {
          dispatch(logout());
        });
        navigate("/", { replace: true });
        window.location.reload();
      },
    });
  };
  //
  const toggle = () => {
    setModal(!modal);
  };

  const getConsoleEnableDat = () => {
    if (Usertoken && currentUser) {
      const masterKey = consoleEnableKey;
      dispatch(GetDataActiveDeactive({ currentUser, Usertoken, masterKey }));
    }
  };

  useEffect(() => {
    if (_.isEmpty(consoleEnable)) {
      getConsoleEnableDat();
    }
  }, [Usertoken, consoleEnable]);

  return (
    <>
      <Navbar
        color={
          currentUser.role == "1" ||
            currentUser.role == "2" ||
            currentUser.role == "8"
            ? topbarColor
            : topbarColor
        }
        dark={!isDarkMode}
        light={isDarkMode}
        expand="lg"
        className={`${currentUser.role == "1" ||
          currentUser.role == "2" ||
          currentUser.role == "8"
          ? "topbarAdmin admin_head_bg"
          : "topbar"
          } 
        ${currentUser.role == "1" || currentUser.role == "2" ? "px-md-2" : ""}`}
      >
        {/********Logo*******/}
        {currentUser.role == "1" || currentUser.role == "2" ? (
          <Link to="/Dashboards/AdminDashboard" className="d-none d-lg-flex">
            <Logo />
          </Link>
        ) : null}

        {currentUser.role !== "1" || currentUser.role !== "2" ? (
          <Button
            close
            size="sm"
            className="d-none"
            onClick={() => dispatch(ToggleMobileSidebar())}
          />
        ) : null}

        {currentUser.role !== "1" ? (
          <div className="d-flex align-items-center">
            <Button
              className="d-none d-lg-block toggle-btnStyle"
              onClick={() => dispatch(ToggleMiniSidebar())}
            >
              <i class="fa-solid fa-bars" />
            </Button>
            <Button
              className="d-sm-block d-lg-none toggle-btnStyle"
              onClick={() => dispatch(ToggleMobileSidebar())}
            >
              <i class="fa-solid fa-bars" />
            </Button>
          </div>
        ) : null}

        {currentUser.role == "1" ? (
          <div className="logo-section">
            <Link
              to="/Dashboards/AdminDashboard"
              className="d-sm-block d-lg-none"
            >
              <img src={mobLogo} width={40} alt="" />
            </Link>
            <Button
              className="d-sm-block d-lg-none toggle-btnStyle"
              onClick={() => dispatch(ToggleMobileSidebar())}
            >
              <i class="fa-solid fa-bars" />
            </Button>
          </div>
        ) : null}

        <div className="text-center d-flex flex-row" navbar>
          <span className="header-text d-md-block d-none">
            Dashboard - WELCOME, {loginData?.username}!
          </span>

        </div>

        <div className="d-flex align-items-center">
          {currentUser.role == "1" ? (
            <span
              className="mr-20 d-md-block d-none"
              onClick={() => setOpenWalletModal(true)}
            >
              <i className="bi bi-wallet2 wallet-icon" />
            </span>
          ) : null}


          {currentUser.role == "6" ? (<><QRToWallet /></>) : null}

          <div
            className="wallet-box"
            onClick={() => setshowBalance(!showBalance)}
          >
            <span>
              {currentUser.userName === "PFRT000009" ? null : (
                <>
                  Balance:{" "}
                  {showBalance && (
                    <span style={{ display: "inline-flex", gap: "20px" }}>
                      <span className="balance-amount">
                        PG Wallet : {`\u20B9`} {loginData?.pG_Wallet_Balance}
                      </span>

                      <span className="balance-amount">
                        Main Wallet : {`\u20B9`}{" "}
                        {loginData?.main_Wallet_Balance}
                      </span>
                    </span>
                  )}
                </>
              )}
            </span>
          </div>
          {/******************************/}
          {/**********Mega DD**********/}
          {/******************************/}

          {/******************************/}
          {/**********Notification DD**********/}
          {/******************************/}
          {currentUser.RoleName !== "Admin" ? (
            // <UncontrolledDropdown className="mx-1 hov-dd d-md-block d-none">
            <UncontrolledDropdown className="mx-1 hov-dd   d-none">
              <DropdownToggle
                className="bg-transparent border-0"
                color={topbarColor}
              >
                <Icon.MessageSquare size={18} />
              </DropdownToggle>
              <DropdownMenu className="ddWidth">
                <div className="bg-info p-3 text-white rounded-top">
                  Notification
                </div>
                <SimpleBar style={{ maxHeight: "350px" }}>
                  <NotificationDD />
                </SimpleBar>
                <DropdownItem divider />
                <div className="p-2 px-3">
                  <Button color="info" size="sm" block>
                    Check All
                  </Button>
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          ) : null}
          {/******************************/}
          {/**********Message DD**********/}
          {/******************************/}
          {currentUser.RoleName !== "Admin" ? (
            // <UncontrolledDropdown className="mx-1 hov-dd d-md-block d-none">
            <UncontrolledDropdown className="mx-1 hov-dd   d-none">
              <DropdownToggle
                className="bg-transparent border-0"
                color={topbarColor}
              >
                <Icon.Mail size={18} />
              </DropdownToggle>
              <DropdownMenu className="ddWidth">
                <div className="bg-danger p-3 text-white rounded-top">
                  Messages
                </div>
                <SimpleBar style={{ maxHeight: "350px" }}>
                  <MessageDD />
                </SimpleBar>
                <DropdownItem divider />
                <div className="p-2 px-3">
                  <Button color="danger" size="sm" block>
                    Check All
                  </Button>
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          ) : null}
          {/******************************/}
          {/**********Profile DD**********/}
          {/******************************/}
          <UncontrolledDropdown>
            <DropdownToggle className="logout-btn">
              <span>
                {loginData?.firstName} {loginData?.lastName}
              </span>
              <img
                src={user1}
                alt="user"
                width="30"
                className="rounded-circle mx-1"
              />
            </DropdownToggle>
            <DropdownMenu className="logout-box">
              <ProfileDD />
              <Button
                color="danger"
                size="sm"
                className="m-2"
                onClick={handleLogoutClick}
              >
                Logout
              </Button>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </Navbar>
      {modal ? (
        <Col xs="8" md="12">
          <Modal isOpen={toggle} fade={false} toggle={toggle.bind(null)}>
            <ModalHeader
              toggle={toggle.bind(null)}
              style={{ padding: "10px", color: "#000" }}
            >
              UPI Collection
            </ModalHeader>
            <ModalBody>
              <Row className="row">
                <Col md="4">
                  {/* <img
                    src={baseB4 + QRimage}
                    alt="123"
                    style={{ width: '150px', border: '1px solid #dfe2e6' }}
                  /> */}
                </Col>
                <Col md="8" className="mt-0">
                  <Table className="table-bordered">
                    <thead>
                      <tr>
                        <td className="text-nowrap text-black">Name </td>
                      </tr>
                      <tr>
                        <td className="text-nowrap text-black">UPI ID </td>
                        {/* <td>{UPIID}</td> */}
                      </tr>
                    </thead>
                  </Table>
                  <Row>
                    <img
                      src={phonepe}
                      alt="phonepe"
                      style={{ width: "60px" }}
                    />
                    <img src={gpay} alt="gpay" style={{ width: "60px" }} />
                    <img src={upi} alt="upi" style={{ width: "60px" }} />
                    <img src={paytm} alt="paytm" style={{ width: "60px" }} />
                  </Row>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
        </Col>
      ) : null}
      {openWalletModal && (
        <ReactStrapModal
          modal={openWalletModal}
          setModal={() => setOpenWalletModal(false)}
          isHeader
          isToggle
          title="Self TopUp"
          className="editModelDmt"
          size="sm"
          styles={{ width: "400px" }}
        >
          <CreditSelfAdmin
            setOpenWalletModal={() => setOpenWalletModal(false)}
          />
        </ReactStrapModal>
      )}
    </>
  );
};

export default Header;
